export default {
    REMIND_PASS_FORM__CHANGE_EMAIL: 'REMIND_PASS_FORM__CHANGE_EMAIL',
    REMIND_PASS_FORM__SHOW_SUCCESSFUL_MESSAGE:
        'REMIND_PASS_FORM__SHOW_SUCCESSFUL_MESSAGE',
    REMIND_PASS_FORM__SHOW_ERROR: 'REMIND_PASS_FORM__SHOW_ERROR',
    REMIND_PASS_FORM__SUBMIT: 'REMIND_PASS_FORM__SUBMIT',
    REMIND_PASS_FORM__VALIDATE: 'REMIND_PASS_FORM__VALIDATE',
};
